import React, { useState } from 'react';
//import { usersMock } from './mockData';
import "./css/login.css";
import {API_BASE_URL, UserGetAPIEndPoint} from "../constant.js"

/*function Login({ setIsLoggedIn }) {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = () => {
    const user = usersMock.find(u => u.username === form.username && u.password === form.password);
    if (user) {
      setIsLoggedIn(true);
      navigate('/');
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <div>
      <h1>Login</h1>
      <input placeholder="Username" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} />
      <input type="password" placeholder="Password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
      <button onClick={handleLogin}>Login</button>
      {error && <p style={{color:'red'}}>{error}</p>}
    </div>
  );
}*/





const Login = () => {
  let hostname = window.location.hostname;  
 hostname = hostname.replace("www.", ""); // Remove 'www.' if present
 hostname = hostname.replace("https://", ""); // Remove 'https.' if present
 hostname = hostname.replace("http://", ""); // Remove 'http.' if present

const SiteDomain =  hostname.includes(".apexenterprise.shop")? hostname.split(".")[0] : "dev Mode";
  



 


  const [form, setForm] = useState({
    username: "",
    password: ""
  });

  const handleChange = async(e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();

    if (!form.username || !form.password) {
      alert("All fields are required");
      return;
    }

    /*const user = usersMock.find(u => u.username === form.username && u.password === form.password);
    if(user){
      window.location.href = "/dashboard";
      sessionStorage.setItem("token", "dummy-token");
    }*/

    // TODO: call login API
    try{
        const updateApiURL = API_BASE_URL + UserGetAPIEndPoint;
        const payload = {
          ...form  // existing form fields
        };


         const response = await fetch(updateApiURL,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });

      const result = await response.json();
      if (result.status) {
        window.location.href = "/dashboard";
        sessionStorage.setItem("token", "dummy-token");
        sessionStorage.setItem("userId", result.data.id);
        sessionStorage.setItem("userName", result.data.username);
        sessionStorage.setItem("userType", result.data.usertype);
        sessionStorage.setItem("residentId", result.data.resident_id);
        sessionStorage.setItem("apartment", result.data.apartment);
        sessionStorage.setItem("JWTtoken", result.data.token);
        console.log("Loggedin successfully");
        // console.log("Token => " + result.data.token);
        // console.log("Token => " + result.data.token_length);
        // console.log("test => " + result.data.test);
        // console.log("Payload => " + JSON.stringify(result.data.payload));
        // console.log("JWT_Secret => " + result.data.JWT_Secret);
      }else {
          alert(result.message);
        }
      }catch(e){
      alert("Server error");
    }    
  };

  return (<>
    
    <div className="login-container">
      <div className="login-card">
        <center>
          <img style={{ width: "210px" }} src={`/${SiteDomain}-logo.png`} alt="Logo" /> 
          <div style={{ textTransform: "capitalize" }}> <h2> {SiteDomain} </h2> </div>
        </center>        
        
        <h2>Society Maintenance</h2>
       <p className="subtitle">Login to your account</p>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Username</label>
            <input
              type="text"
              name="username"
              value={form.username}
              onChange={handleChange}
              placeholder="Enter username"
            />
          </div>

          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="Enter password"
            />
          </div>
          <div style={{ textAlign: "right" }}>
            <a href="/forgot-password" className="forgot-password-link">
              Forgot Password?
            </a>
          </div>
          <button type="submit" className="login-btn">
            Login
          </button>
        </form>

        <div className="footer-text" style={{ textTransform: "capitalize" }}>
          © {new Date().getFullYear()} | {SiteDomain} | Society Management
        </div>
      </div>
    </div>
  </>);
};
export default Login;
